import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatQueueTranscriptsFoundEvent} from 'api/types/events'
import {NinchatState} from 'api/types'

export const queueTranscriptsFound: CaseReducer<NinchatState> = (state, action) => {
    const {
        queue_id,
        queue_transcripts,
        ...rest
    } = extractProperties<NinchatQueueTranscriptsFoundEvent>(action.payload)

    isEmpty(rest)

    state._queue_transcripts[queue_id] = queue_transcripts
}
